import type { CodeItem } from "@/types/code-values"

function getGroup(groupName: string): CodeItem[] {
  if (typeof window === "undefined") return []
  return window.PhoenixCodeValues?.[groupName] ?? []
}

export const codeValueService = {
  getCodeValueText(id: number, groupName: string): string {
    const item = this.getCodeValue(id, groupName)
    return item?.text ?? ""
  },

  getCodeValueCode(id: number, groupName: string): string {
    const item = this.getCodeValue(id, groupName)
    return item?.code ?? ""
  },

  getCodeValueIdByCode(code: string, groupName: string): number | null {
    const item = this.getCodeValueByCode(code, groupName)
    return item?.id ?? null
  },

  getCodeValueTextByCode(code: string, groupName: string): string {
    const item = this.getCodeValueByCode(code, groupName)
    return item?.text ?? ""
  },

  getCodeValue(id: number, groupName: string): CodeItem | null {
    return getGroup(groupName).find((c) => c.id === Number(id)) ?? null
  },

  getCodeValueByCode(code: string, groupName: string): CodeItem | null {
    return getGroup(groupName).find((c) => c.code === code) ?? null
  },

  getCodeValues(groupName: string, required = true): CodeItem[] {
    const result = [...getGroup(groupName)].sort((a, b) =>
      a.text.localeCompare(b.text)
    )
    if (!required) {
      result.unshift({
        id: 0,
        groupName,
        parentCode: "",
        parentGroup: "",
        code: "",
        text: "   ",
        description: "",
        sortOrder: -1,
        Icon: "",
      })
    }
    return result
  },

  getCodeValueGroup(groupName: string): CodeItem[] {
    return getGroup(groupName)
  },
}
